export async function wpRESTPost(endpoint, data = {}) {
  const uri = window.wpParams.restURL + endpoint;

  const res = await fetch(uri, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-WP-Nonce': window.wpParams.restNonce,
      Accept: 'application/json',
    },
    credentials: 'same-origin',
    body: JSON.stringify(data),
  });

  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(
      `Request failed: ${res.status} ${res.statusText}${text ? ` - ${text}` : ''}`,
    );
  }

  const json = await res.json();
  return json.data;
}

export async function wpRESTGet(endpoint) {
  const uri = window.wpParams.restURL + endpoint;

  const res = await fetch(uri, {
    method: 'GET',
    headers: {
      'X-WP-Nonce': window.wpParams.restNonce,
      Accept: 'application/json',
    },
    credentials: 'same-origin',
  });

  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(
      `Request failed: ${res.status} ${res.statusText}${text ? ` - ${text}` : ''}`,
    );
  }

  return res.json();
}
